import React from 'react';
import { Button, Dialog } from "@blueprintjs/core";

class MaTraCuuDialog extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: false
    }
  }

  render() {
    return (
      <Dialog
        isOpen={this.props.open}
        onClose={this.props.onClose}
        className="reception-dialog popup-tc wrap-block"
        >
        <div className="pt-dialog-body">
          <p className="reception-dialog-text">Mã tra cứu đơn</p>
          <p className="ma-tc">{this.props.code}</p>
        </div>
        <div className="pt-dialog-footer">
          <div className="pt-dialog-footer-actions reception-delete-confirm">
            <Button
              onClick={this.props.onClose}
              text="Đóng"
              name="closeDialog"
              className="btn-default"
            />
          </div>
        </div>
      </Dialog>
    );
  }
}

MaTraCuuDialog.defaultProps = {
  code: ''
}

export default MaTraCuuDialog;



// WEBPACK FOOTER //
// ./src/components/modules/dialog/MaTraCuuDialog.jsx